// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonBrand = {
  appName: "AI Exam",
} as const;
